// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__f-xBl","rootCenter":"LoadMoreObserver_rootCenter__18Ggj","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__uTA5J"};